import PropTypes from 'prop-types';
import { noCase } from 'change-case';
import { useRef, useState, useEffect, memo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Icon } from '@iconify/react';
import bellFill from '@iconify/icons-eva/bell-fill';
import clockFill from '@iconify/icons-eva/clock-fill';
import doneAllFill from '@iconify/icons-eva/done-all-fill';
// material
import { alpha } from '@material-ui/core/styles';
import {
  Box,
  List,
  Badge,
  Button,
  Avatar,
  Tooltip,
  Divider,
  Typography,
  ListItemText,
  ListSubheader,
  ListItemAvatar,
  ListItemButton,
  Dialog,
  DialogTitle,
  Stack
} from '@material-ui/core';
// utils
import mockData from '../../utils/mock-data';
import { fToNow } from '../../utils/formatTime';
// components
import Scrollbar from '../../components/Scrollbar';
import MenuPopover from '../../components/MenuPopover';
import { MIconButton } from '../../components/@material-extend';
import { useSelector } from 'react-redux';
import { objectID } from '../../utils/objectID';
import apiNotification from '../../api/notification';
import { DialogAnimate } from '../../components/animate';
import DetailNotification from '../../components/_dashboard/notification/DetailNotification';
import { useDispatch } from '../../redux/store';
import { viewNotification as getViewNotification } from '../../redux/slices/notification';

// ----------------------------------------------------------------------

const TITLES = [
  'Your order is placed',
  'Sylvan King',
  'You have new message',
  'You have new mail',
  'Delivery processing'
];

const DESCRIPTIONS = [
  'waiting for shipping',
  'answered to your comment on the Minimal',
  '5 unread messages',
  'sent from Guido Padberg',
  'Your order is being shipped'
];

const TYPES = ['order_placed', 'friend_interactive', 'chat_message', 'mail', 'order_shipped'];

const AVATARS = [null, mockData.image.avatar(2), null, null, null];

const UNREADS = [true, true, false, false, false];



// ----------------------------------------------------------------------

function renderContent(notification) {
  const title = (
    <Typography variant="subtitle2">
      {notification.title}
      <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
        &nbsp; {noCase(notification.description)}
      </Typography>
    </Typography>
  );

  if (notification.type === 'order_placed') {
    return {
      avatar: <img alt={notification.title} src="/static/icons/ic_notification_package.svg" />,
      title
    };
  }
  if (notification.type === 'order_shipped') {
    return {
      avatar: <img alt={notification.title} src="/static/icons/ic_notification_shipping.svg" />,
      title
    };
  }
  if (notification.type === 'mail') {
    return {
      avatar: <img alt={notification.title} src="/static/icons/ic_notification_mail.svg" />,
      title
    };
  }
  if (notification.type === 'chat_message') {
    return {
      avatar: <img alt={notification.title} src="/static/icons/ic_notification_chat.svg" />,
      title
    };
  }
  return {
    avatar: <img alt={notification.title} src={notification.avatar} />,
    title
  };
}





export default memo(function NotificationsPopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { viewNotification } = useSelector(state => state.notification);
  const [viewNotificationRead, setviewNotificationRead] = useState([]);
  const [viewNotificationUnread, setviewNotificationUnread] = useState([]);

  const [detailNotification, setDetailNotification] = useState(null);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {

    setviewNotificationUnread(viewNotification.filter(noti => noti.is_read.length === 0));
    setviewNotificationRead(viewNotification.filter(noti => noti.is_read.length === 1));
  }, [viewNotification]);
  console.log(viewNotificationUnread);
  console.log(viewNotificationRead)
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const 
  handleMarkAllAsRead = async () => {
    const res_detail_noti = await apiNotification.mark_all_as_read({});
    dispatch(getViewNotification());
  };
  const onDetailNotification = async (id) => {
    const res_detail_noti = await apiNotification.view({ id: id });
    setDetailNotification(res_detail_noti.data.data);
    setIsOpenModal(true);
    console.log('load load load load ');
    dispatch(getViewNotification());
    console.log('hehêhehe');
  }

  const handleCloseModal = () => {
    setIsOpenModal(false)
  }
  const NotificationItem = ({ notification }) => {
    // const { avatar, title } = renderContent(notification);


    return (
      <ListItemButton
        disableGutters
        onClick={() => onDetailNotification(objectID(notification._id))}
        sx={{
          py: 1.5,
          px: 2.5,
          mt: '1px',
          ...(notification?.is_read.length === 0 && {
            bgcolor: 'action.selected'
          })
        }}

      >

        <ListItemAvatar>
          <Icon icon={"carbon:ticket"} color="red" width={48} height={48} />
          {/* <Avatar sx={{ bgcolor: 'background.neutral' }}>{notification.title}</Avatar> */}
        </ListItemAvatar>
        <ListItemText
          primary={
            <Stack direction={"column"}>
              <Typography sx={{ color: '#303187', fontSize: '14px', fontWeight: '700', lineHeight: '20px', letterSpacing: '-0.32px' }} >{notification.title}</Typography>
              <Typography sx={{ fontSize: '12', lineHeight: '20px', letterSpacing: '-0.32px' }}  >{notification.content_summary}</Typography>
            </Stack>}
          secondary={
            <Typography
              variant="caption"
              rowGap={3}
              sx={{
                mt: 0.5,
                display: 'flex',
                alignItems: 'center',
                color: 'text.disabled'
              }}
            >
              <Box component={Icon} icon={clockFill} sx={{ mr: 0.5, width: 16, height: 16 }} />
              {fToNow(notification.date_start)}
            </Typography>
          }
        />
      </ListItemButton>
    );
  }
  return (
    <>
      <MIconButton
        ref={anchorRef}
        size="large"
        color={open ? 'primary' : 'default'}
        onClick={handleOpen}
        sx={{
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
          })
        }}
      >
        <Badge badgeContent={viewNotificationUnread.length} color="error">
          <Icon icon={bellFill} width={20} height={20} />
        </Badge>
      </MIconButton>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ width: 360 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">Thông báo</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Bạn có {viewNotificationUnread.length} thông báo chưa đọc
            </Typography>
          </Box>

          {viewNotificationUnread.length > 0 && (
            <Tooltip title=" Mark all as read">
              <MIconButton color="primary" onClick={handleMarkAllAsRead}>
                <Icon icon={doneAllFill} width={20} height={20} />
              </MIconButton>
            </Tooltip>
          )}
        </Box>

        <Divider />

        <Scrollbar sx={{ height: { xs: 340, sm: 'auto', lg: 400, xl: 400 } }}>
          {viewNotificationUnread.length > 0 &&
            <List
              disablePadding
              subheader={
                <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                  Tin nhắn mới nhất
                </ListSubheader>
              }
            >
              {viewNotificationUnread.map((notification) => (
                <NotificationItem key={notification.id} notification={notification} />
              ))}
            </List>
          }
          <List
            disablePadding
            subheader={
              <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                Tin nhắn trước đó
              </ListSubheader>
            }
          >
            {viewNotificationRead.map((notification) => (
              <NotificationItem key={notification.id} notification={notification} />
            ))}
          </List>
        </Scrollbar>



        <Divider />

        <Box sx={{ p: 1 }}>
          <Button onClick={()=>handleClose()} fullWidth disableRipple component={RouterLink} to="/notification/list">
           Xem tất cả
          </Button>
        </Box>
        <Box sx={{ width: "100%", border: 1 }}>
          <Box sx={{ height: "15px", width: '75%', float: "right", background: "#41c7f5", clipPath: 'polygon(0 0, 100% 0, 100% 100%, 5% 100%)' }}> </Box>
          <Box sx={{ height: "15px", width: '40%', background: "red", clipPath: 'polygon(0 0, 83% 0, 100% 100%, 0 100%)' }}> </Box>
        </Box>
        <DialogAnimate fullWidth maxWidth="md" open={isOpenModal} onClose={handleCloseModal}>
          <DialogTitle sx={{ py: 2 }}>Chi tiết thông báo</DialogTitle>
          <DetailNotification detailNotification={detailNotification} handleCloseModal={handleCloseModal} />
        </DialogAnimate>
      </MenuPopover>
    </>
  );
})
